import React from 'react';
import '../styles/faq.css'; // reuse your faq styles

const faqs = [
  {
    question: "How much does a website cost?",
    answer: "Website costs vary depending on features, design complexity, and integrations. We provide tailored quotes based on your requirements."
  },
  {
    question: "How long does it take to build a website?",
    answer: "Most websites are completed within 3-12 weeks, depending on size and functionality. Larger projects may take longer."
  },
  {
    question: "Will my website be mobile-friendly?",
    answer: "Yes. All websites we build are fully responsive and optimized for mobile, tablet, and desktop devices."
  },
  {
    question: "Can I update my website after it’s launched?",
    answer: "Absolutely. We build user-friendly websites on CMS platforms so you can manage and update content without coding knowledge."
  },
  {
    question: "Is SEO included in website development?",
    answer: "Yes. We follow SEO best practices during development, clean code, fast load times, and metadata setup, to help your site rank better."
  },
  {
    question: "Do you provide training for my website?",
    answer: "Yes, training is included with every website package to ensure you can manage your site confidently."
  }
];

const WebsiteFAQs = () => {
  return (
    <section className="faq-section">
      <h2 className="faq-title">Frequently Asked Questions</h2>
      <div className="faq-grid">
        {faqs.map((item, index) => (
          <div className="faq-item" key={index}>
            <h3 className="faq-question">{item.question}</h3>
            <p className="faq-answer">{item.answer}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default WebsiteFAQs;
